import clsx from 'clsx';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import { formatGroupPremiumValue } from '@/App/tiles/Option/strategy/groupedPricing.ts';
import { getPremiumSuffix } from '@/App/tiles/Option/strategy/GroupedPricingSummary/utils.ts';
import type { PremiumType } from '@/store/option/state.ts';

type GroupPremiumValueProps = {
  value: number;
  premiumType: PremiumType;
  currency: string;
  currencyPairPrecision: number;
  isInternalSales: boolean;
  isExpired: boolean;
};

export function GroupPremiumValue(props: GroupPremiumValueProps) {
  const { value, premiumType, currency } = props;
  const displayValue = formatGroupPremiumValue(value, premiumType.premiumCategory, props.currencyPairPrecision);
  const fractionDigits = premiumType.premiumCategory === 'PERCENT' || premiumType.premiumCategory === 'PPS' ? 4 : 2;

  // Legacy selects Bid for both zero and negative zero after rounding.
  const way = displayValue < 0 ? 'Ask' : 'Bid';

  return (
    <span className={clsx('text-nowrap fw-bolder', { 'text-secondary': props.isExpired })}>
      <FormattedMessage id={`optiontile.rates.wayResult.${way}`} values={{ isInternalSales: props.isInternalSales }} />{' '}
      <FormattedNumber
        value={Math.abs(displayValue)}
        minimumFractionDigits={fractionDigits}
        maximumFractionDigits={fractionDigits}
      />
      {getPremiumSuffix(premiumType, currency)}
    </span>
  );
}
